import { render, staticRenderFns } from "./SendPressageView.vue?vue&type=template&id=371cb253&scoped=true&"
import script from "./SendPressageView.vue?vue&type=script&lang=js&"
export * from "./SendPressageView.vue?vue&type=script&lang=js&"
import style0 from "./SendPressageView.vue?vue&type=style&index=0&id=371cb253&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cb253",
  null
  
)

export default component.exports